// extracted by mini-css-extract-plugin
module.exports = {"credits":"credits_29TOxGov"};